import React, { Component } from 'react';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../actions/asyncStateAction';
import servicesConfig from '../../services/servicesConfig';
import * as HTML_RENDITION from '../../utils/general/general';
import Loading from '../../utils/animation/loading';
import shortid from 'shortid';
import Ellipsis from '../../utils/general/Ellipsis';
import { enterKeyPressed } from '../../utils/general/enterKey';
import moment from "moment";
import _, { isEmpty, isEqual, split } from 'lodash';
import {localI18nData} from "../../utils/general/resourceBundleServices";
import { urlCopyFunc } from './../../utils/api/appControl';
// import {RenditionLoadable} from '../../../js/utils/general/LoadableRelated';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import RenditionUrlGenerator from '../../utils/api/renditionUrlGenerator';
import '../../../style/newRebranding/features/stacks.scss';

const _HTML_RENDITION: any = window.HTML_RENDITION;

interface IWhatsTrendingProps {
    initialData: any;
    docHeaderJsonData: any;
    stacksTrendingData: any;
    applyTrendingData: () => {};
    showOldBranding: boolean;
    menuCode: any;
}

interface IWhatsTrendingStatus {
    firstRenderTime: number | undefined;
}

export class WhatsTrending extends Component<IWhatsTrendingProps, IWhatsTrendingStatus> {

    constructor(props: IWhatsTrendingProps) {
        super(props);
        props.applyTrendingData();
        this.state = {
            firstRenderTime: undefined,
        }
    }

    public componentDidMount() {
        this.setState({firstRenderTime: Date.now()});        
    }

    public componentWillUnmount() {
        this.setState({firstRenderTime: undefined});
    }

    public refreshContent(stacktype: string) {
        this.props.applyTrendingData();
    }

    public async seeMore(stacktype: string) {
        RSCH_HTML_TRACKING_CONFIG.trackWhatsTrendingSeeMore('WHATS TRENDING SEEMORE');
        const baseUrl = this.props.initialData.html_origin;
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        const whatTrendingUrl = baseUrl + '/cvr/citiresearchui/eppublic/whats_trending';
        const environment = window.HTML_RENDITION.initialData.environment;
        const menuCode = this.props.menuCode;
        let whatTrendingCvFrameUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment)+ '/cv2/go/RSCH_LANDING_PAGE/' + btoa('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/whats_trending');
        try {
            // if(!isEmpty(menuCode) && !isEqual(menuCode, 'RSCH_LANDING_PAGE')) {
            //     whatTrendingCvFrameUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment)+ `/cv2/go/${menuCode}/` + HTML_RENDITION.base64urlEncode('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/pure/whats_trending');
            // }
            window.open(whatTrendingCvFrameUrl, '_blank');
        } catch (error) {
            console.error('seeMore::', error);
        }
    }

    public openDocument(e: any, stackType: string, docId: string, parentDocId: string, docUrl: string,headline :string, count: string, position: number){
            if (e) {
                e.preventDefault();
            }
            if (_.isEmpty(docId)) {
                return;
            }

            if (HTML_RENDITION.isBloomBerg()) {
                let docLinkUrl = HTML_RENDITION.getDocumentLink(Base64.encode('doc_id=' + docId))
                docLinkUrl = RenditionUrlGenerator.URL_GENERATOR.environments(window.HTML_RENDITION.initialData.environment) + HTML_RENDITION.addParentDocDataParam(docLinkUrl);
                console.log('BloomBerg What trending :: openDocument ::docId::docUrl::', docId, docLinkUrl);
                HTML_RENDITION.BloomBergExecutionWithDocId(docId, docLinkUrl, true);
                return;
            }
            if (window.HTML_RENDITION.initialData.showOldLoading) {
                HTML_RENDITION.showLoadMask();
                setTimeout(() => {
                    HTML_RENDITION.hideLoadMask();
                }, 10000);   
            }         

            const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
            RSCH_HTML_TRACKING_CONFIG.trackWhatsTrendingDocumentClick( 'whatsTrending',headline,count,position,docId,parentDocId,docUrl)
    
            
            let docUrlWithCVFrame = HTML_RENDITION.getCVFrameUrl(this.props.menuCode, docUrl, 'all_research');
            // if(isCvFrameMapping) {
            //     const environment = window.HTML_RENDITION.initialData.environment;
            //     const whatTrendingUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment)+ '/cv2/go/RSCH_LANDING_PAGE/' + btoa('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/all_research/iframe/' + btoa(docUrl));
            //     window.open(whatTrendingUrl, '_blank');
            //     return;  
            // } 
            if (HTML_RENDITION.isAppInsideCViFrame() && !HTML_RENDITION.isAppInsideCVResearchUIiFrame()) {
                HTML_RENDITION.changeCVUrl(docUrl);
            } else {
                window.open(docUrlWithCVFrame, '_blank');
            }        
    }

    public enterKeyPressedFn = (e: any,stackCode: string, docId: string, parentDocId: string, docLinkUrl: string, headline: string,count:string,position: number) => {
        const code = e.keyCode || e.which;
        if (code === 13 || code === 32) {
            this.openDocument(e, stackCode, docId, parentDocId, docLinkUrl,headline,count,position);
        }
    }

    public stackContent(data: any, stacktype: string) {
        const docs: Array<any> = [];
        const errorMsg = (
            <div key={shortid.generate()} style={{ padding: '10px', color: '#e60000' }} >
                <div>The What's Trending list is temporarily unavailable.</div>
                <div>Please click<a tabIndex={0} aria-label='Please click here to try again.' style={{color:'#005aa1'}}
                onClick={() => this.refreshContent(stacktype)} role="button"
                onKeyPress={(e) => enterKeyPressed(e, this.refreshContent.bind(this, stacktype))}
                > here </a>to try again.</div>
            </div>
        );

        if (!data.isDataGot) {
            if (HTML_RENDITION.isPreview() && !data.data.results) { // show error msg when in preview && no data coming and page render elapsed more than 5000 ms
                let timeEllapsed: number = 0;
                if (this.state.firstRenderTime) {
                    timeEllapsed = Date.now() - this.state.firstRenderTime;
                    if (timeEllapsed > 5000) {
                        docs.push(errorMsg); 
                    }                    
                }              
                return docs;                
            }
            if (window.HTML_RENDITION.initialData.showOldLoading) {
                docs.push(<Loading key={shortid.generate()} scale={0.5} overrideStyle={{ position: 'relative', left: '116px' }} />);
            }
            return docs;
        }

        if (!data.data || !data.data.length) {
            docs.push(errorMsg);
            return docs;
        }

        for (let idx = 0; idx < data.data.length; idx++) {
            const result = data.data[idx];
            const count = data.data.length;
            const docId = result.SUBMISSIONID || '';
            const headline = result.HEADLINE || '';
            const publicationDate = result.PUBLICATIONDATE || '';
            const docDate =  moment(publicationDate).format("D MMM YYYY");
            const docLinkUrl = result.renditionUrl || '';
            const position = idx+1;

            const doc = [];
            doc.push(
                <div className='research' key={idx + 'research'}>
                    <div className='titleBlock'>
                        <a tabIndex={0} className='headlineTitle'
                           role="link"
                           onClick={(e) => this.openDocument(e, stacktype, docId, _HTML_RENDITION.parent_doc_id, docLinkUrl,headline,count,position)}
                           onKeyPress={(e) => this.enterKeyPressedFn(e, stacktype, docId, _HTML_RENDITION.parent_doc_id, docLinkUrl,headline,count,position)}
                        >
                            <Ellipsis line={2}><span className='headlineText'>{headline}</span></Ellipsis>
                        </a>
                    </div>
                    <div className='docDate'>{docDate}</div>
                </div>);
            docs.push(doc);
        }

        return <div key={shortid.generate()}>{docs}</div>;
    }

    // public loadBranding() {
    //     let Branding: any;
    
    //     if (this.props.showOldBranding) {
    //       Branding = RenditionLoadable({
    //         loader: () => import('../../../dynamicComponents/stacksOld'),
    //       }, 'stacksOld', Date.now());
    //     }
    //     else {
    //       Branding = RenditionLoadable({
    //         loader: () => import('../../../dynamicComponents/stacksNew'),
    //       }, 'stacksNew', Date.now());
    //     }
    
    //     return <Branding/>;
    //   }

    public render() {
        const { docHeaderJsonData, stacksTrendingData } = this.props;
        const i18n = localI18nData(docHeaderJsonData.metadata.isJP).data;
        const whatsTrendingTitle = i18n.whatsTrendingTitle;
        const see_more_text = i18n.seeMoreText;
        return (
            <React.Fragment>
                {/* {this.loadBranding()} */}
                <div key={shortid.generate()} id='whats_trending_stacks'>
                    <div className="whats-trending-part" key={"whats-trending-part"}>
                        <div key={"whats-trending"} className={'stack_title whats-trending_title'}>
                            <span className='stack_name'>{whatsTrendingTitle}</span>
                            {!HTML_RENDITION.isBloomBerg() && <a tabIndex={0} id={'whats-trending_view_more'}
                                onClick={() => this.seeMore('trending')}
                                onKeyPress={(e) => enterKeyPressed(e, this.seeMore.bind(this, 'trending'))}
                                aria-label={see_more_text + ' ' + whatsTrendingTitle} role="button">{see_more_text + " >"}<span style={{ fontSize: '15px' }}></span>
                            </a>}
                        </div>
                        {this.stackContent(stacksTrendingData, 'trending')}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        stacksTrendingData: state.asyncStateReducer.stacksTrendingData,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
        menuCode: state.commonStateReducer.menuCode,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        applyTrendingData: () => dispatch(asyncStateAction.fetchStacksData(servicesConfig.GET_STACKS, 'TRENDING')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsTrending);